/**
 * This code was generated by Builder.io.
 */
import React from "react";
import styles from "./InspectorProfile.module.css";

function Header() {
    return (
        <header className={`${styles.header} tw-bg-tertiary`}>
            <button className={`${styles.backButton} tw-bg-primary hover:tw-bg-primary_hover`}>
                <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/b206dc90a7feaef38e2d5071e5a12fdc819ad136b2135aa5938ad2a3e407928f?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                    alt=""
                    className={styles.backIcon}
                />
                <span>Back to list</span>
            </button>
            <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/e8736165426314ab60453eb0732176362cf59b8627f4e9b441e4b3c65bb0952d?placeholderIfAbsent=true&apiKey=355710932fa240f1a51c362a9b36f625"
                alt="Company Logo"
                className={styles.logo}
            />
        </header>
    );
}

export default Header;
